module.exports = __webpack_public_path__ + "img/hatch-thankyou-hero.dfbc322d.png";